import { styled, TableRow } from '@mui/material';
import { TableRow as MUITableRow } from '@mui/material';
import { FC, type JSX } from 'react';

interface Props {
  content: JSX.Element;
  'data-testid'?: string;
  href?: string;
  deleted?: boolean;
}

const StyledTableRow = styled(TableRow)() as typeof MUITableRow;

export const ResultsTableRow: FC<Props> = ({ content, href, deleted = false, ...props }) => {
  const hasLink = href !== undefined;

  return (
    <StyledTableRow
      component={(!hasLink) ? 'div' : 'a'}
      data-testid={props['data-testid']}
      hover
      href={href}
      sx={{ cursor: (!hasLink) ? 'default' : 'pointer', height: '60px', textDecoration: deleted ? 'line-through' : 'none' }}
    >
      {content}
    </StyledTableRow>
  );
};
